import { HttpService } from '@/infra/http'
import type { TCreateCadastrarClienteData } from '@/types/cliente'

export class UpdateClienteService extends HttpService {
  async execute(id: string, cliente: TCreateCadastrarClienteData) {
    const response = await this.http.put(`api/v2/Cliente/alterar/${id}`, cliente)
    return response
  }
}
